// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "openai.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "openai.proto" (syntax proto3)
// tslint:disable
import { URLObject } from "./s3";
import { FileObjects } from "./s3";
import { String$ } from "./common";
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "./common";
// @generated message type with reflection information, may provide speed optimized methods
class ThreadMessageList$Type extends MessageType {
    constructor() {
        super("ThreadMessageList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ThreadMessage },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ThreadMessage results */ 1:
                    message.results.push(ThreadMessage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ThreadMessage results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ThreadMessage.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ThreadMessageList
 */
export const ThreadMessageList = new ThreadMessageList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ThreadMessage$Type extends MessageType {
    constructor() {
        super("ThreadMessage", [
            { no: 1, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string message */ 1:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string message = 1; */
        if (message.message !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ThreadMessage
 */
export const ThreadMessage = new ThreadMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamMessageRequest$Type extends MessageType {
    constructor() {
        super("StreamMessageRequest", [
            { no: 1, name: "user", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "assistant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.user = "";
        message.assistantId = "";
        message.threadId = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user */ 1:
                    message.user = reader.string();
                    break;
                case /* string assistant_id */ 2:
                    message.assistantId = reader.string();
                    break;
                case /* string thread_id */ 3:
                    message.threadId = reader.string();
                    break;
                case /* string message */ 4:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string user = 1; */
        if (message.user !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.user);
        /* string assistant_id = 2; */
        if (message.assistantId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.assistantId);
        /* string thread_id = 3; */
        if (message.threadId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.threadId);
        /* string message = 4; */
        if (message.message !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message StreamMessageRequest
 */
export const StreamMessageRequest = new StreamMessageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamMessage$Type extends MessageType {
    constructor() {
        super("StreamMessage", [
            { no: 1, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string message */ 1:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string message = 1; */
        if (message.message !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StreamMessage
 */
export const StreamMessage = new StreamMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckThreadRequest$Type extends MessageType {
    constructor() {
        super("CheckThreadRequest", [
            { no: 1, name: "assistant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "thread_run_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.assistantId = "";
        message.threadId = "";
        message.threadRunId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string assistant_id */ 1:
                    message.assistantId = reader.string();
                    break;
                case /* string thread_id */ 2:
                    message.threadId = reader.string();
                    break;
                case /* string thread_run_id */ 3:
                    message.threadRunId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string assistant_id = 1; */
        if (message.assistantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.assistantId);
        /* string thread_id = 2; */
        if (message.threadId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.threadId);
        /* string thread_run_id = 3; */
        if (message.threadRunId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.threadRunId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CheckThreadRequest
 */
export const CheckThreadRequest = new CheckThreadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddingMessageRequest$Type extends MessageType {
    constructor() {
        super("AddingMessageRequest", [
            { no: 1, name: "assistant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.assistantId = "";
        message.threadId = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string assistant_id */ 1:
                    message.assistantId = reader.string();
                    break;
                case /* string thread_id */ 2:
                    message.threadId = reader.string();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string assistant_id = 1; */
        if (message.assistantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.assistantId);
        /* string thread_id = 2; */
        if (message.threadId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.threadId);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message AddingMessageRequest
 */
export const AddingMessageRequest = new AddingMessageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddingMessageResponse$Type extends MessageType {
    constructor() {
        super("AddingMessageResponse", [
            { no: 1, name: "thread_run_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.threadRunId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string thread_run_id */ 1:
                    message.threadRunId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string thread_run_id = 1; */
        if (message.threadRunId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.threadRunId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message AddingMessageResponse
 */
export const AddingMessageResponse = new AddingMessageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartThreadRequest$Type extends MessageType {
    constructor() {
        super("StartThreadRequest", [
            { no: 1, name: "assistant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tool_resources", kind: "message", T: () => ToolResources }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.assistantId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string assistant_id */ 1:
                    message.assistantId = reader.string();
                    break;
                case /* ToolResources tool_resources */ 2:
                    message.toolResources = ToolResources.internalBinaryRead(reader, reader.uint32(), options, message.toolResources);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string assistant_id = 1; */
        if (message.assistantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.assistantId);
        /* ToolResources tool_resources = 2; */
        if (message.toolResources)
            ToolResources.internalBinaryWrite(message.toolResources, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message StartThreadRequest
 */
export const StartThreadRequest = new StartThreadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartThreadResponse$Type extends MessageType {
    constructor() {
        super("StartThreadResponse", [
            { no: 1, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.threadId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string thread_id */ 1:
                    message.threadId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string thread_id = 1; */
        if (message.threadId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.threadId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message StartThreadResponse
 */
export const StartThreadResponse = new StartThreadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Assistant$Type extends MessageType {
    constructor() {
        super("Assistant", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "metadata", kind: "message", T: () => Any },
            { no: 7, name: "tools", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tool },
            { no: 8, name: "tool_resources", kind: "message", T: () => ToolResources },
            { no: 9, name: "temperature", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "top_p", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.model = "";
        message.name = "";
        message.description = "";
        message.instructions = "";
        message.tools = [];
        message.temperature = 0;
        message.topP = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string model */ 2:
                    message.model = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* string instructions */ 5:
                    message.instructions = reader.string();
                    break;
                case /* Any metadata */ 6:
                    message.metadata = Any.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                case /* repeated Tool tools */ 7:
                    message.tools.push(Tool.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* ToolResources tool_resources */ 8:
                    message.toolResources = ToolResources.internalBinaryRead(reader, reader.uint32(), options, message.toolResources);
                    break;
                case /* float temperature */ 9:
                    message.temperature = reader.float();
                    break;
                case /* float top_p */ 10:
                    message.topP = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string model = 2; */
        if (message.model !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.model);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* string instructions = 5; */
        if (message.instructions !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.instructions);
        /* Any metadata = 6; */
        if (message.metadata)
            Any.internalBinaryWrite(message.metadata, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated Tool tools = 7; */
        for (let i = 0; i < message.tools.length; i++)
            Tool.internalBinaryWrite(message.tools[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* ToolResources tool_resources = 8; */
        if (message.toolResources)
            ToolResources.internalBinaryWrite(message.toolResources, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* float temperature = 9; */
        if (message.temperature !== 0)
            writer.tag(9, WireType.Bit32).float(message.temperature);
        /* float top_p = 10; */
        if (message.topP !== 0)
            writer.tag(10, WireType.Bit32).float(message.topP);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message Assistant
 */
export const Assistant = new Assistant$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantList$Type extends MessageType {
    constructor() {
        super("AssistantList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Assistant },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Assistant results */ 1:
                    message.results.push(Assistant.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Assistant results = 1; */
        for (let i = 0; i < message.results.length; i++)
            Assistant.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message AssistantList
 */
export const AssistantList = new AssistantList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantThread$Type extends MessageType {
    constructor() {
        super("AssistantThread", [
            { no: 1, name: "Id", kind: "scalar", jsonName: "Id", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "UserId", kind: "scalar", jsonName: "UserId", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "AssistantId", kind: "scalar", jsonName: "AssistantId", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "ThreadId", kind: "scalar", jsonName: "ThreadId", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "RunId", kind: "scalar", jsonName: "RunId", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "Status", kind: "scalar", jsonName: "Status", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "Response", kind: "scalar", jsonName: "Response", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "ServiceType", kind: "scalar", jsonName: "ServiceType", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "DateCreated", kind: "scalar", jsonName: "DateCreated", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "LastUpdate", kind: "scalar", jsonName: "LastUpdate", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "IsActive", kind: "scalar", jsonName: "IsActive", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "status_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.userId = 0;
        message.assistantId = "";
        message.threadId = "";
        message.runId = "";
        message.status = "";
        message.response = "";
        message.serviceType = "";
        message.dateCreated = "";
        message.lastUpdate = "";
        message.isActive = false;
        message.fieldMask = [];
        message.statusList = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 Id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 UserId */ 2:
                    message.userId = reader.int32();
                    break;
                case /* string AssistantId */ 3:
                    message.assistantId = reader.string();
                    break;
                case /* string ThreadId */ 4:
                    message.threadId = reader.string();
                    break;
                case /* string RunId */ 5:
                    message.runId = reader.string();
                    break;
                case /* string Status */ 6:
                    message.status = reader.string();
                    break;
                case /* string Response */ 7:
                    message.response = reader.string();
                    break;
                case /* string ServiceType */ 8:
                    message.serviceType = reader.string();
                    break;
                case /* string DateCreated */ 9:
                    message.dateCreated = reader.string();
                    break;
                case /* string LastUpdate */ 10:
                    message.lastUpdate = reader.string();
                    break;
                case /* bool IsActive */ 11:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 12:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string status_list */ 19:
                    message.statusList = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 Id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 UserId = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* string AssistantId = 3; */
        if (message.assistantId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.assistantId);
        /* string ThreadId = 4; */
        if (message.threadId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.threadId);
        /* string RunId = 5; */
        if (message.runId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.runId);
        /* string Status = 6; */
        if (message.status !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.status);
        /* string Response = 7; */
        if (message.response !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.response);
        /* string ServiceType = 8; */
        if (message.serviceType !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.serviceType);
        /* string DateCreated = 9; */
        if (message.dateCreated !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.dateCreated);
        /* string LastUpdate = 10; */
        if (message.lastUpdate !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.lastUpdate);
        /* bool IsActive = 11; */
        if (message.isActive !== false)
            writer.tag(11, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 12; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string status_list = 19; */
        if (message.statusList !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.statusList);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AssistantThread
 */
export const AssistantThread = new AssistantThread$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantThreadList$Type extends MessageType {
    constructor() {
        super("AssistantThreadList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AssistantThread },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated AssistantThread results */ 1:
                    message.results.push(AssistantThread.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated AssistantThread results = 1; */
        for (let i = 0; i < message.results.length; i++)
            AssistantThread.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message AssistantThreadList
 */
export const AssistantThreadList = new AssistantThreadList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadOpenAiFile$Type extends MessageType {
    constructor() {
        super("UploadOpenAiFile", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "purpose", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.path = "";
        message.purpose = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string path */ 1:
                    message.path = reader.string();
                    break;
                case /* string purpose */ 2:
                    message.purpose = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string path = 1; */
        if (message.path !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.path);
        /* string purpose = 2; */
        if (message.purpose !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.purpose);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UploadOpenAiFile
 */
export const UploadOpenAiFile = new UploadOpenAiFile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OpenAiFile$Type extends MessageType {
    constructor() {
        super("OpenAiFile", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "purpose", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.createdAt = "";
        message.fileName = "";
        message.purpose = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string created_at */ 2:
                    message.createdAt = reader.string();
                    break;
                case /* string file_name */ 3:
                    message.fileName = reader.string();
                    break;
                case /* string purpose */ 4:
                    message.purpose = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string created_at = 2; */
        if (message.createdAt !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.createdAt);
        /* string file_name = 3; */
        if (message.fileName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.fileName);
        /* string purpose = 4; */
        if (message.purpose !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.purpose);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message OpenAiFile
 */
export const OpenAiFile = new OpenAiFile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OpenAiFileList$Type extends MessageType {
    constructor() {
        super("OpenAiFileList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OpenAiFile },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated OpenAiFile results */ 1:
                    message.results.push(OpenAiFile.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated OpenAiFile results = 1; */
        for (let i = 0; i < message.results.length; i++)
            OpenAiFile.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message OpenAiFileList
 */
export const OpenAiFileList = new OpenAiFileList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VectorStoreRequest$Type extends MessageType {
    constructor() {
        super("VectorStoreRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "file_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.fileIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* repeated string file_ids */ 2:
                    message.fileIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* repeated string file_ids = 2; */
        for (let i = 0; i < message.fileIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.fileIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VectorStoreRequest
 */
export const VectorStoreRequest = new VectorStoreRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VectorStore$Type extends MessageType {
    constructor() {
        super("VectorStore", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VectorStore
 */
export const VectorStore = new VectorStore$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VectorStoreList$Type extends MessageType {
    constructor() {
        super("VectorStoreList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => VectorStore },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated VectorStore results */ 1:
                    message.results.push(VectorStore.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated VectorStore results = 1; */
        for (let i = 0; i < message.results.length; i++)
            VectorStore.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VectorStoreList
 */
export const VectorStoreList = new VectorStoreList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VectorStoreFilesRequest$Type extends MessageType {
    constructor() {
        super("VectorStoreFilesRequest", [
            { no: 1, name: "vector_store_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "file_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.vectorStoreId = "";
        message.fileIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string vector_store_id */ 1:
                    message.vectorStoreId = reader.string();
                    break;
                case /* repeated string file_ids */ 2:
                    message.fileIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string vector_store_id = 1; */
        if (message.vectorStoreId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.vectorStoreId);
        /* repeated string file_ids = 2; */
        for (let i = 0; i < message.fileIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.fileIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VectorStoreFilesRequest
 */
export const VectorStoreFilesRequest = new VectorStoreFilesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VectorStoreFile$Type extends MessageType {
    constructor() {
        super("VectorStoreFile", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "vector_store_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.vectorStoreId = "";
        message.status = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string vector_store_id */ 2:
                    message.vectorStoreId = reader.string();
                    break;
                case /* string status */ 3:
                    message.status = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string vector_store_id = 2; */
        if (message.vectorStoreId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.vectorStoreId);
        /* string status = 3; */
        if (message.status !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VectorStoreFile
 */
export const VectorStoreFile = new VectorStoreFile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VectorStoreFileList$Type extends MessageType {
    constructor() {
        super("VectorStoreFileList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => VectorStoreFile },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated VectorStoreFile results */ 1:
                    message.results.push(VectorStoreFile.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated VectorStoreFile results = 1; */
        for (let i = 0; i < message.results.length; i++)
            VectorStoreFile.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VectorStoreFileList
 */
export const VectorStoreFileList = new VectorStoreFileList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolResources$Type extends MessageType {
    constructor() {
        super("ToolResources", [
            { no: 1, name: "code_interpreter", kind: "message", T: () => CodeInterpreter },
            { no: 2, name: "file_search", kind: "message", T: () => FileSearch }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CodeInterpreter code_interpreter */ 1:
                    message.codeInterpreter = CodeInterpreter.internalBinaryRead(reader, reader.uint32(), options, message.codeInterpreter);
                    break;
                case /* FileSearch file_search */ 2:
                    message.fileSearch = FileSearch.internalBinaryRead(reader, reader.uint32(), options, message.fileSearch);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* CodeInterpreter code_interpreter = 1; */
        if (message.codeInterpreter)
            CodeInterpreter.internalBinaryWrite(message.codeInterpreter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* FileSearch file_search = 2; */
        if (message.fileSearch)
            FileSearch.internalBinaryWrite(message.fileSearch, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ToolResources
 */
export const ToolResources = new ToolResources$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CodeInterpreter$Type extends MessageType {
    constructor() {
        super("CodeInterpreter", [
            { no: 1, name: "file_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.fileIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string file_ids */ 1:
                    message.fileIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated string file_ids = 1; */
        for (let i = 0; i < message.fileIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.fileIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CodeInterpreter
 */
export const CodeInterpreter = new CodeInterpreter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileSearch$Type extends MessageType {
    constructor() {
        super("FileSearch", [
            { no: 1, name: "vector_store_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.vectorStoreIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string vector_store_ids */ 1:
                    message.vectorStoreIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated string vector_store_ids = 1; */
        for (let i = 0; i < message.vectorStoreIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.vectorStoreIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FileSearch
 */
export const FileSearch = new FileSearch$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VectorStores$Type extends MessageType {
    constructor() {
        super("VectorStores", [
            { no: 1, name: "file_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.fileIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string file_ids */ 1:
                    message.fileIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated string file_ids = 1; */
        for (let i = 0; i < message.fileIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.fileIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VectorStores
 */
export const VectorStores = new VectorStores$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Tool$Type extends MessageType {
    constructor() {
        super("Tool", [
            { no: 1, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.type = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string type */ 1:
                    message.type = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string type = 1; */
        if (message.type !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Tool
 */
export const Tool = new Tool$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantMessageRequest$Type extends MessageType {
    constructor() {
        super("AssistantMessageRequest", [
            { no: 1, name: "assistant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "assistant_thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "messages", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.assistantId = "";
        message.assistantThreadId = "";
        message.messages = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string assistant_id */ 1:
                    message.assistantId = reader.string();
                    break;
                case /* string assistant_thread_id */ 2:
                    message.assistantThreadId = reader.string();
                    break;
                case /* repeated string messages */ 3:
                    message.messages.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string assistant_id = 1; */
        if (message.assistantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.assistantId);
        /* string assistant_thread_id = 2; */
        if (message.assistantThreadId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.assistantThreadId);
        /* repeated string messages = 3; */
        for (let i = 0; i < message.messages.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.messages[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message AssistantMessageRequest
 */
export const AssistantMessageRequest = new AssistantMessageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantMessageResponse$Type extends MessageType {
    constructor() {
        super("AssistantMessageResponse", [
            { no: 1, name: "assistant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "assistant_thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.assistantId = "";
        message.assistantThreadId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string assistant_id */ 1:
                    message.assistantId = reader.string();
                    break;
                case /* string assistant_thread_id */ 2:
                    message.assistantThreadId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string assistant_id = 1; */
        if (message.assistantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.assistantId);
        /* string assistant_thread_id = 2; */
        if (message.assistantThreadId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.assistantThreadId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message AssistantMessageResponse
 */
export const AssistantMessageResponse = new AssistantMessageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantThreadRequest$Type extends MessageType {
    constructor() {
        super("AssistantThreadRequest", [
            { no: 1, name: "assistant_thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.assistantThreadId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string assistant_thread_id */ 1:
                    message.assistantThreadId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string assistant_thread_id = 1; */
        if (message.assistantThreadId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.assistantThreadId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message AssistantThreadRequest
 */
export const AssistantThreadRequest = new AssistantThreadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantThreadResponse$Type extends MessageType {
    constructor() {
        super("AssistantThreadResponse", [
            { no: 1, name: "assistant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "assistant_thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "thread_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "thread_response", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.assistantId = "";
        message.assistantThreadId = "";
        message.threadStatus = "";
        message.threadResponse = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string assistant_id */ 1:
                    message.assistantId = reader.string();
                    break;
                case /* string assistant_thread_id */ 2:
                    message.assistantThreadId = reader.string();
                    break;
                case /* string thread_status */ 3:
                    message.threadStatus = reader.string();
                    break;
                case /* string thread_response */ 4:
                    message.threadResponse = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string assistant_id = 1; */
        if (message.assistantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.assistantId);
        /* string assistant_thread_id = 2; */
        if (message.assistantThreadId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.assistantThreadId);
        /* string thread_status = 3; */
        if (message.threadStatus !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.threadStatus);
        /* string thread_response = 4; */
        if (message.threadResponse !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.threadResponse);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message AssistantThreadResponse
 */
export const AssistantThreadResponse = new AssistantThreadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResponseModelRequest$Type extends MessageType {
    constructor() {
        super("ResponseModelRequest", [
            { no: 1, name: "model", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "input", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "background", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.model = "";
        message.input = "";
        message.userId = 0;
        message.background = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string model */ 1:
                    message.model = reader.string();
                    break;
                case /* string input */ 2:
                    message.input = reader.string();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* bool background */ 4:
                    message.background = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string model = 1; */
        if (message.model !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.model);
        /* string input = 2; */
        if (message.input !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.input);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* bool background = 4; */
        if (message.background !== false)
            writer.tag(4, WireType.Varint).bool(message.background);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ResponseModelRequest
 */
export const ResponseModelRequest = new ResponseModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResponsePromptRequest$Type extends MessageType {
    constructor() {
        super("ResponsePromptRequest", [
            { no: 1, name: "prompt_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "input", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "background", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "variables", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 6, name: "memo_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.promptId = "";
        message.input = "";
        message.userId = 0;
        message.background = false;
        message.variables = {};
        message.memoIds = [];
        message.createdAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string prompt_id */ 1:
                    message.promptId = reader.string();
                    break;
                case /* string input */ 2:
                    message.input = reader.string();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* bool background */ 4:
                    message.background = reader.bool();
                    break;
                case /* map<string, string> variables */ 5:
                    this.binaryReadMap5(message.variables, reader, options);
                    break;
                case /* repeated int32 memo_ids */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.memoIds.push(reader.int32());
                    else
                        message.memoIds.push(reader.int32());
                    break;
                case /* string created_at */ 7:
                    message.createdAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    binaryReadMap5(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for ResponsePromptRequest.variables");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message, writer, options) {
        /* string prompt_id = 1; */
        if (message.promptId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.promptId);
        /* string input = 2; */
        if (message.input !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.input);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* bool background = 4; */
        if (message.background !== false)
            writer.tag(4, WireType.Varint).bool(message.background);
        /* map<string, string> variables = 5; */
        for (let k of globalThis.Object.keys(message.variables))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.variables[k]).join();
        /* repeated int32 memo_ids = 6; */
        if (message.memoIds.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.memoIds.length; i++)
                writer.int32(message.memoIds[i]);
            writer.join();
        }
        /* string created_at = 7; */
        if (message.createdAt !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.createdAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ResponsePromptRequest
 */
export const ResponsePromptRequest = new ResponsePromptRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AiResponse$Type extends MessageType {
    constructor() {
        super("AiResponse", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "created_by_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "responses_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "memo_ids", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "model", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "prompt_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "prompt_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "input", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "response", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.createdByUserId = 0;
        message.responsesId = "";
        message.status = "";
        message.memoIds = "";
        message.model = "";
        message.promptName = "";
        message.promptId = "";
        message.input = "";
        message.response = "";
        message.createdAt = "";
        message.isActive = false;
        message.fieldMask = [];
        message.orderBy = "";
        message.orderDir = "";
        message.dateTarget = [];
        message.dateRange = [];
        message.pageNumber = 0;
        message.idList = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 created_by_user_id */ 2:
                    message.createdByUserId = reader.int32();
                    break;
                case /* string responses_id */ 3:
                    message.responsesId = reader.string();
                    break;
                case /* string status */ 4:
                    message.status = reader.string();
                    break;
                case /* string memo_ids = 5 [deprecated = true] */ 5:
                    message.memoIds = reader.string();
                    break;
                case /* string model */ 6:
                    message.model = reader.string();
                    break;
                case /* string prompt_name */ 7:
                    message.promptName = reader.string();
                    break;
                case /* string prompt_id */ 8:
                    message.promptId = reader.string();
                    break;
                case /* string input */ 9:
                    message.input = reader.string();
                    break;
                case /* string response */ 10:
                    message.response = reader.string();
                    break;
                case /* string created_at */ 11:
                    message.createdAt = reader.string();
                    break;
                case /* bool is_active */ 12:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 13:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string order_by */ 14:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 15:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string date_target */ 16:
                    message.dateTarget.push(reader.string());
                    break;
                case /* repeated string date_range */ 17:
                    message.dateRange.push(reader.string());
                    break;
                case /* int32 page_number */ 18:
                    message.pageNumber = reader.int32();
                    break;
                case /* string id_list */ 19:
                    message.idList = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 created_by_user_id = 2; */
        if (message.createdByUserId !== 0)
            writer.tag(2, WireType.Varint).int32(message.createdByUserId);
        /* string responses_id = 3; */
        if (message.responsesId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.responsesId);
        /* string status = 4; */
        if (message.status !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.status);
        /* string memo_ids = 5 [deprecated = true]; */
        if (message.memoIds !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.memoIds);
        /* string model = 6; */
        if (message.model !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.model);
        /* string prompt_name = 7; */
        if (message.promptName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.promptName);
        /* string prompt_id = 8; */
        if (message.promptId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.promptId);
        /* string input = 9; */
        if (message.input !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.input);
        /* string response = 10; */
        if (message.response !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.response);
        /* string created_at = 11; */
        if (message.createdAt !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.createdAt);
        /* bool is_active = 12; */
        if (message.isActive !== false)
            writer.tag(12, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 13; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string order_by = 14; */
        if (message.orderBy !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 15; */
        if (message.orderDir !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string date_target = 16; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(16, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* repeated string date_range = 17; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(17, WireType.LengthDelimited).string(message.dateRange[i]);
        /* int32 page_number = 18; */
        if (message.pageNumber !== 0)
            writer.tag(18, WireType.Varint).int32(message.pageNumber);
        /* string id_list = 19; */
        if (message.idList !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.idList);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AiResponse
 */
export const AiResponse = new AiResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AiResponseList$Type extends MessageType {
    constructor() {
        super("AiResponseList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AiResponse },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated AiResponse results */ 1:
                    message.results.push(AiResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated AiResponse results = 1; */
        for (let i = 0; i < message.results.length; i++)
            AiResponse.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AiResponseList
 */
export const AiResponseList = new AiResponseList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAiResponseReq$Type extends MessageType {
    constructor() {
        super("SearchAiResponseReq", [
            { no: 1, name: "memo_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "proposal_intake_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.memoId = 0;
        message.proposalIntakeId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 memo_id */ 1:
                    message.memoId = reader.int32();
                    break;
                case /* int32 proposal_intake_id */ 2:
                    message.proposalIntakeId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 memo_id = 1; */
        if (message.memoId !== 0)
            writer.tag(1, WireType.Varint).int32(message.memoId);
        /* int32 proposal_intake_id = 2; */
        if (message.proposalIntakeId !== 0)
            writer.tag(2, WireType.Varint).int32(message.proposalIntakeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SearchAiResponseReq
 */
export const SearchAiResponseReq = new SearchAiResponseReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AiChatPrompt$Type extends MessageType {
    constructor() {
        super("AiChatPrompt", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "prompt_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "prompt_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.promptName = "";
        message.promptId = "";
        message.createdAt = "";
        message.isActive = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string prompt_name */ 2:
                    message.promptName = reader.string();
                    break;
                case /* string prompt_id */ 3:
                    message.promptId = reader.string();
                    break;
                case /* string created_at */ 4:
                    message.createdAt = reader.string();
                    break;
                case /* bool is_active */ 5:
                    message.isActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string prompt_name = 2; */
        if (message.promptName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.promptName);
        /* string prompt_id = 3; */
        if (message.promptId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.promptId);
        /* string created_at = 4; */
        if (message.createdAt !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.createdAt);
        /* bool is_active = 5; */
        if (message.isActive !== false)
            writer.tag(5, WireType.Varint).bool(message.isActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AiChatPrompt
 */
export const AiChatPrompt = new AiChatPrompt$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AiChatPromptList$Type extends MessageType {
    constructor() {
        super("AiChatPromptList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AiChatPrompt },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated AiChatPrompt results */ 1:
                    message.results.push(AiChatPrompt.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated AiChatPrompt results = 1; */
        for (let i = 0; i < message.results.length; i++)
            AiChatPrompt.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AiChatPromptList
 */
export const AiChatPromptList = new AiChatPromptList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AiResponseSystem$Type extends MessageType {
    constructor() {
        super("AiResponseSystem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "ai_responses_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "memo_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "proposal_intake_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.aiResponsesId = 0;
        message.memoId = 0;
        message.proposalIntakeId = 0;
        message.createdAt = "";
        message.fieldMask = [];
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 ai_responses_id */ 2:
                    message.aiResponsesId = reader.int32();
                    break;
                case /* int32 memo_id */ 3:
                    message.memoId = reader.int32();
                    break;
                case /* int32 proposal_intake_id */ 4:
                    message.proposalIntakeId = reader.int32();
                    break;
                case /* string created_at */ 5:
                    message.createdAt = reader.string();
                    break;
                case /* repeated string field_mask */ 6:
                    message.fieldMask.push(reader.string());
                    break;
                case /* bool without_limit */ 7:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 ai_responses_id = 2; */
        if (message.aiResponsesId !== 0)
            writer.tag(2, WireType.Varint).int32(message.aiResponsesId);
        /* int32 memo_id = 3; */
        if (message.memoId !== 0)
            writer.tag(3, WireType.Varint).int32(message.memoId);
        /* int32 proposal_intake_id = 4; */
        if (message.proposalIntakeId !== 0)
            writer.tag(4, WireType.Varint).int32(message.proposalIntakeId);
        /* string created_at = 5; */
        if (message.createdAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdAt);
        /* repeated string field_mask = 6; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* bool without_limit = 7; */
        if (message.withoutLimit !== false)
            writer.tag(7, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AiResponseSystem
 */
export const AiResponseSystem = new AiResponseSystem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AiResponseSystemList$Type extends MessageType {
    constructor() {
        super("AiResponseSystemList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AiResponseSystem },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated AiResponseSystem results */ 1:
                    message.results.push(AiResponseSystem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated AiResponseSystem results = 1; */
        for (let i = 0; i < message.results.length; i++)
            AiResponseSystem.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AiResponseSystemList
 */
export const AiResponseSystemList = new AiResponseSystemList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AiResponseReport$Type extends MessageType {
    constructor() {
        super("AiResponseReport", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "report_date_start", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "report_date_end", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "ai_responses_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "job_numbers", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.text = "";
        message.timestamp = "";
        message.reportDateStart = "";
        message.reportDateEnd = "";
        message.isActive = false;
        message.aiResponsesId = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.idList = "";
        message.jobNumbers = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string text */ 2:
                    message.text = reader.string();
                    break;
                case /* string timestamp */ 3:
                    message.timestamp = reader.string();
                    break;
                case /* string report_date_start */ 4:
                    message.reportDateStart = reader.string();
                    break;
                case /* string report_date_end */ 5:
                    message.reportDateEnd = reader.string();
                    break;
                case /* bool is_active */ 6:
                    message.isActive = reader.bool();
                    break;
                case /* int32 ai_responses_id */ 12:
                    message.aiResponsesId = reader.int32();
                    break;
                case /* repeated string field_mask */ 7:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 8:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 9:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 10:
                    message.orderDir = reader.string();
                    break;
                case /* string id_list */ 11:
                    message.idList = reader.string();
                    break;
                case /* string job_numbers */ 13:
                    message.jobNumbers = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string text = 2; */
        if (message.text !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.text);
        /* string timestamp = 3; */
        if (message.timestamp !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.timestamp);
        /* string report_date_start = 4; */
        if (message.reportDateStart !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reportDateStart);
        /* string report_date_end = 5; */
        if (message.reportDateEnd !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.reportDateEnd);
        /* bool is_active = 6; */
        if (message.isActive !== false)
            writer.tag(6, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 7; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 8; */
        if (message.pageNumber !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 9; */
        if (message.orderBy !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 10; */
        if (message.orderDir !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.orderDir);
        /* string id_list = 11; */
        if (message.idList !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.idList);
        /* int32 ai_responses_id = 12; */
        if (message.aiResponsesId !== 0)
            writer.tag(12, WireType.Varint).int32(message.aiResponsesId);
        /* string job_numbers = 13; */
        if (message.jobNumbers !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.jobNumbers);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AiResponseReport
 */
export const AiResponseReport = new AiResponseReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AiResponseReportList$Type extends MessageType {
    constructor() {
        super("AiResponseReportList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AiResponseReport },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated AiResponseReport results */ 1:
                    message.results.push(AiResponseReport.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated AiResponseReport results = 1; */
        for (let i = 0; i < message.results.length; i++)
            AiResponseReport.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AiResponseReportList
 */
export const AiResponseReportList = new AiResponseReportList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AiResponseReportFile$Type extends MessageType {
    constructor() {
        super("AiResponseReportFile", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "ai_response_report_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "is_selected", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "display_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "file_memo_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "memo_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "memo_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "memo_property_address_search", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "file_bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.aiResponseReportId = 0;
        message.fileId = 0;
        message.isActive = false;
        message.isSelected = false;
        message.displayOrder = 0;
        message.fileMemoId = 0;
        message.memoEventId = 0;
        message.memoDescription = "";
        message.memoPropertyAddressSearch = "";
        message.fileName = "";
        message.fileBucket = "";
        message.fieldMask = [];
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 ai_response_report_id */ 2:
                    message.aiResponseReportId = reader.int32();
                    break;
                case /* int32 file_id */ 3:
                    message.fileId = reader.int32();
                    break;
                case /* bool is_active */ 4:
                    message.isActive = reader.bool();
                    break;
                case /* bool is_selected */ 5:
                    message.isSelected = reader.bool();
                    break;
                case /* int32 display_order */ 10:
                    message.displayOrder = reader.int32();
                    break;
                case /* int32 file_memo_id */ 11:
                    message.fileMemoId = reader.int32();
                    break;
                case /* int32 memo_event_id */ 12:
                    message.memoEventId = reader.int32();
                    break;
                case /* string memo_description */ 13:
                    message.memoDescription = reader.string();
                    break;
                case /* string memo_property_address_search */ 14:
                    message.memoPropertyAddressSearch = reader.string();
                    break;
                case /* string file_name */ 6:
                    message.fileName = reader.string();
                    break;
                case /* string file_bucket */ 7:
                    message.fileBucket = reader.string();
                    break;
                case /* repeated string field_mask */ 8:
                    message.fieldMask.push(reader.string());
                    break;
                case /* bool without_limit */ 9:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 ai_response_report_id = 2; */
        if (message.aiResponseReportId !== 0)
            writer.tag(2, WireType.Varint).int32(message.aiResponseReportId);
        /* int32 file_id = 3; */
        if (message.fileId !== 0)
            writer.tag(3, WireType.Varint).int32(message.fileId);
        /* bool is_active = 4; */
        if (message.isActive !== false)
            writer.tag(4, WireType.Varint).bool(message.isActive);
        /* bool is_selected = 5; */
        if (message.isSelected !== false)
            writer.tag(5, WireType.Varint).bool(message.isSelected);
        /* string file_name = 6; */
        if (message.fileName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.fileName);
        /* string file_bucket = 7; */
        if (message.fileBucket !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.fileBucket);
        /* repeated string field_mask = 8; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* bool without_limit = 9; */
        if (message.withoutLimit !== false)
            writer.tag(9, WireType.Varint).bool(message.withoutLimit);
        /* int32 display_order = 10; */
        if (message.displayOrder !== 0)
            writer.tag(10, WireType.Varint).int32(message.displayOrder);
        /* int32 file_memo_id = 11; */
        if (message.fileMemoId !== 0)
            writer.tag(11, WireType.Varint).int32(message.fileMemoId);
        /* int32 memo_event_id = 12; */
        if (message.memoEventId !== 0)
            writer.tag(12, WireType.Varint).int32(message.memoEventId);
        /* string memo_description = 13; */
        if (message.memoDescription !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.memoDescription);
        /* string memo_property_address_search = 14; */
        if (message.memoPropertyAddressSearch !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.memoPropertyAddressSearch);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AiResponseReportFile
 */
export const AiResponseReportFile = new AiResponseReportFile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AiResponseReportFileList$Type extends MessageType {
    constructor() {
        super("AiResponseReportFileList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AiResponseReportFile },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated AiResponseReportFile results */ 1:
                    message.results.push(AiResponseReportFile.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated AiResponseReportFile results = 1; */
        for (let i = 0; i < message.results.length; i++)
            AiResponseReportFile.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AiResponseReportFileList
 */
export const AiResponseReportFileList = new AiResponseReportFileList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchUpdateAiResponseReportFilesRequest$Type extends MessageType {
    constructor() {
        super("BatchUpdateAiResponseReportFilesRequest", [
            { no: 1, name: "updates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AiResponseReportFile }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated AiResponseReportFile updates */ 1:
                    message.updates.push(AiResponseReportFile.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated AiResponseReportFile updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            AiResponseReportFile.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BatchUpdateAiResponseReportFilesRequest
 */
export const BatchUpdateAiResponseReportFilesRequest = new BatchUpdateAiResponseReportFilesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AiResponseReportData$Type extends MessageType {
    constructor() {
        super("AiResponseReportData", [
            { no: 1, name: "report", kind: "message", T: () => AiResponseReport },
            { no: 2, name: "files", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AiResponseReportFileWithUrl }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.files = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* AiResponseReport report */ 1:
                    message.report = AiResponseReport.internalBinaryRead(reader, reader.uint32(), options, message.report);
                    break;
                case /* repeated AiResponseReportFileWithUrl files */ 2:
                    message.files.push(AiResponseReportFileWithUrl.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* AiResponseReport report = 1; */
        if (message.report)
            AiResponseReport.internalBinaryWrite(message.report, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated AiResponseReportFileWithUrl files = 2; */
        for (let i = 0; i < message.files.length; i++)
            AiResponseReportFileWithUrl.internalBinaryWrite(message.files[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AiResponseReportData
 */
export const AiResponseReportData = new AiResponseReportData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AiResponseReportFileWithUrl$Type extends MessageType {
    constructor() {
        super("AiResponseReportFileWithUrl", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "file_bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "expiring_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "display_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "is_selected", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "memo_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "memo_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "memo_property_address_search", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "base64_data", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.fileId = 0;
        message.fileName = "";
        message.fileBucket = "";
        message.expiringUrl = "";
        message.displayOrder = 0;
        message.isSelected = false;
        message.memoEventId = 0;
        message.memoDescription = "";
        message.memoPropertyAddressSearch = "";
        message.mimeType = "";
        message.base64Data = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 file_id */ 2:
                    message.fileId = reader.int32();
                    break;
                case /* string file_name */ 3:
                    message.fileName = reader.string();
                    break;
                case /* string file_bucket */ 4:
                    message.fileBucket = reader.string();
                    break;
                case /* string expiring_url */ 5:
                    message.expiringUrl = reader.string();
                    break;
                case /* int32 display_order */ 6:
                    message.displayOrder = reader.int32();
                    break;
                case /* bool is_selected */ 7:
                    message.isSelected = reader.bool();
                    break;
                case /* int32 memo_event_id */ 8:
                    message.memoEventId = reader.int32();
                    break;
                case /* string memo_description */ 9:
                    message.memoDescription = reader.string();
                    break;
                case /* string memo_property_address_search */ 10:
                    message.memoPropertyAddressSearch = reader.string();
                    break;
                case /* string mime_type */ 11:
                    message.mimeType = reader.string();
                    break;
                case /* string base64_data */ 12:
                    message.base64Data = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 file_id = 2; */
        if (message.fileId !== 0)
            writer.tag(2, WireType.Varint).int32(message.fileId);
        /* string file_name = 3; */
        if (message.fileName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.fileName);
        /* string file_bucket = 4; */
        if (message.fileBucket !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.fileBucket);
        /* string expiring_url = 5; */
        if (message.expiringUrl !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.expiringUrl);
        /* int32 display_order = 6; */
        if (message.displayOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.displayOrder);
        /* bool is_selected = 7; */
        if (message.isSelected !== false)
            writer.tag(7, WireType.Varint).bool(message.isSelected);
        /* int32 memo_event_id = 8; */
        if (message.memoEventId !== 0)
            writer.tag(8, WireType.Varint).int32(message.memoEventId);
        /* string memo_description = 9; */
        if (message.memoDescription !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.memoDescription);
        /* string memo_property_address_search = 10; */
        if (message.memoPropertyAddressSearch !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.memoPropertyAddressSearch);
        /* string mime_type = 11; */
        if (message.mimeType !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.mimeType);
        /* string base64_data = 12; */
        if (message.base64Data !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.base64Data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AiResponseReportFileWithUrl
 */
export const AiResponseReportFileWithUrl = new AiResponseReportFileWithUrl$Type();
/**
 * @generated ServiceType for protobuf service OpenAiService
 */
export const OpenAiService = new ServiceType("OpenAiService", [
    { name: "CreateAssistantThread", options: {}, I: AssistantThread, O: AssistantThread },
    { name: "UpdateAssistantThread", options: {}, I: AssistantThread, O: AssistantThread },
    { name: "DeleteAssistantThread", options: {}, I: AssistantThread, O: Empty },
    { name: "GetAssistantThread", options: {}, I: AssistantThread, O: AssistantThread },
    { name: "BatchGetAssistantThread", options: {}, I: AssistantThread, O: AssistantThreadList },
    { name: "UploadFile", options: {}, I: UploadOpenAiFile, O: OpenAiFile },
    { name: "ListFiles", options: {}, I: Empty, O: OpenAiFileList },
    { name: "DeleteFile", options: {}, I: String$, O: Empty },
    { name: "CreateVectorStore", options: {}, I: VectorStoreRequest, O: VectorStore },
    { name: "ListVectorStores", options: {}, I: Empty, O: VectorStoreList },
    { name: "CreateVectorStoreFiles", options: {}, I: VectorStoreFilesRequest, O: Empty },
    { name: "ListVectorStoreFiles", options: {}, I: VectorStore, O: VectorStoreFileList },
    { name: "DeleteVectorStoreFile", options: {}, I: VectorStoreFile, O: Empty },
    { name: "GetSummaries", options: {}, I: Empty, O: Empty },
    { name: "UploadS3FileList", options: {}, I: FileObjects, O: OpenAiFileList },
    { name: "CreateSimpleResponse", options: {}, I: ResponseModelRequest, O: AiResponse },
    { name: "CreatePromptResponse", options: {}, I: ResponsePromptRequest, O: AiResponse },
    { name: "CreateAiResponse", options: {}, I: AiResponse, O: AiResponse },
    { name: "UpdateAiResponse", options: {}, I: AiResponse, O: AiResponse },
    { name: "DeleteAiResponse", options: {}, I: AiResponse, O: Empty },
    { name: "GetAiResponse", options: {}, I: AiResponse, O: AiResponse },
    { name: "BatchGetAiResponse", options: {}, I: AiResponse, O: AiResponseList },
    { name: "SearchAiResponse", options: {}, I: SearchAiResponseReq, O: AiResponseList },
    { name: "GetAiChatPrompt", options: {}, I: AiChatPrompt, O: AiChatPrompt },
    { name: "BatchGetAiChatPrompt", options: {}, I: AiChatPrompt, O: AiChatPromptList },
    { name: "CreateAiResponsesSystem", options: {}, I: AiResponseSystem, O: AiResponseSystem },
    { name: "UpdateAiResponsesSystem", options: {}, I: AiResponseSystem, O: AiResponseSystem },
    { name: "DeleteAiResponsesSystem", options: {}, I: AiResponseSystem, O: Empty },
    { name: "GetAiResponsesSystem", options: {}, I: AiResponseSystem, O: AiResponseSystem },
    { name: "BatchGetAiResponsesSystem", options: {}, I: AiResponseSystem, O: AiResponseSystemList },
    { name: "CreateAiResponseReport", options: {}, I: AiResponseReport, O: AiResponseReport },
    { name: "UpdateAiResponseReport", options: {}, I: AiResponseReport, O: AiResponseReport },
    { name: "DeleteAiResponseReport", options: {}, I: AiResponseReport, O: Empty },
    { name: "GetAiResponseReport", options: {}, I: AiResponseReport, O: AiResponseReport },
    { name: "BatchGetAiResponseReport", options: {}, I: AiResponseReport, O: AiResponseReportList },
    { name: "CreateAiResponseReportFile", options: {}, I: AiResponseReportFile, O: AiResponseReportFile },
    { name: "UpdateAiResponseReportFile", options: {}, I: AiResponseReportFile, O: AiResponseReportFile },
    { name: "DeleteAiResponseReportFile", options: {}, I: AiResponseReportFile, O: Empty },
    { name: "GetAiResponseReportFile", options: {}, I: AiResponseReportFile, O: AiResponseReportFile },
    { name: "BatchGetAiResponseReportFile", options: {}, I: AiResponseReportFile, O: AiResponseReportFileList },
    { name: "BatchUpdateAiResponseReportFiles", options: {}, I: BatchUpdateAiResponseReportFilesRequest, O: AiResponseReportFileList },
    { name: "GetAiResponseReportData", options: {}, I: AiResponseReport, O: AiResponseReportData },
    { name: "DownloadAiResponseReport", options: {}, I: AiResponseReport, O: URLObject },
    { name: "CreateOpenAiAssistant", options: {}, I: Assistant, O: Assistant },
    { name: "UpdateOpenAiAssistant", options: {}, I: Assistant, O: Assistant },
    { name: "DeleteOpenAiAssistant", options: {}, I: String$, O: Empty },
    { name: "ListAssistants", options: {}, I: Empty, O: AssistantList },
    { name: "StartThread", options: {}, I: StartThreadRequest, O: StartThreadResponse },
    { name: "DeleteThread", options: {}, I: String$, O: Empty },
    { name: "MakeChatCompletionRequest", options: {}, I: String$, O: String$ },
    { name: "AssistantThreadChat", serverStreaming: true, options: {}, I: StreamMessageRequest, O: StreamMessage },
    { name: "AddAssistantThreadMessage", options: {}, I: AssistantMessageRequest, O: AssistantMessageResponse },
    { name: "GetAssistantThreadResponse", options: {}, I: AssistantThreadRequest, O: AssistantThreadResponse }
]);
